import React from 'react';
import ReactDOM from 'react-dom/client';
import Router from './Router';
import { CookiesProvider } from 'react-cookie';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<CookiesProvider>
  <Router />
  </CookiesProvider>
);
